import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UploadViewComponentModule } from '../../../shared/components';
import { CommissionsRoutingModule } from './commissions-routing.module';
import { CommissionsComponent } from './commissions.component';
import { CommissionsService } from './commissions.service';

@NgModule({
    declarations: [CommissionsComponent],
    imports: [
        CommonModule,
        CommissionsRoutingModule,
        UploadViewComponentModule,
    ],
    providers: [CommissionsService],
})
export class CommissionsModule {}
